import FormFieldAPI from './form_field_api';
import AutocompleteFormFieldAPI from './autocomplete_form_field_api';
import RadioFormFieldAPI from './radio_form_field_api';
import CheckboxFormFieldAPI from './checkbox_form_field_api';
import GridFormFieldAPI from './grid_form_field_api';
import ChartFormFieldAPI from './chart_form_field_api';
import LabelFormFieldAPI from './label_form_field_api';

export const create = (formField, constructorArgs = {}) => {
  const apiClass = getAPIClass(formField);
  return new apiClass(Object.assign({
    id: formField.id,
  }, constructorArgs));
};

const getAPIClass = (formField) => {
  switch(formField.component) {
    case 'autocomplete':
      return AutocompleteFormFieldAPI;
    case 'radio':
      return RadioFormFieldAPI;
    case 'gridform':
      return GridFormFieldAPI;
    case 'chart':
      return ChartFormFieldAPI;
    case 'label':
      return LabelFormFieldAPI;
    case 'checkbox':
      return CheckboxFormFieldAPI;
    default:
      return FormFieldAPI;
  }
};

export default {
  create
};
